import React from 'react';
import { profile } from '../data/profile';
import { CornerOrnament } from './CornerOrnament';
import { OrnamentDivider } from './OrnamentDivider';
export function PortraitFrame() {
  return <figure className="mx-auto max-w-md border border-bronze-light/60 bg-ink-soft p-2.5 lg:mx-0" data-id="element-48" data-mp="1pi0mh0l3k3o5">
      <div className="relative border border-bronze-light/35 px-6 pb-8 pt-8 sm:px-9" data-id="element-49" data-mp="1kjz129077s9i">
        <CornerOrnament className="absolute left-1.5 top-1.5 h-12 w-12 text-bronze-light" data-id="element-50" data-mp="2i6y3z1hhhwfu" />
        <CornerOrnament className="absolute right-1.5 top-1.5 h-12 w-12 rotate-90 text-bronze-light" data-id="element-51" data-mp="2d84myz2znnax" />
        <CornerOrnament className="absolute bottom-1.5 right-1.5 h-12 w-12 rotate-180 text-bronze-light" data-id="element-52" data-mp="28heg1hewzce4" />
        <CornerOrnament className="absolute bottom-1.5 left-1.5 h-12 w-12 -rotate-90 text-bronze-light" data-id="element-53" data-mp="23il1rmrszhcw" />

        <div className="border border-bronze-light/70 p-1.5" data-id="element-54" data-mp="30y8sjbzqlx4k">
          <div className="border border-bronze-light/30" data-id="element-55" data-mp="30zs4wri9vo12">
            <img src={profile.photo} alt={`Portrait of ${profile.fullName}`} className="block aspect-[5/6] w-full object-cover object-top" data-id="element-56" data-mp="2w5xp3z5sft79" />
          </div>
        </div>

        <figcaption className="mt-8 text-center" data-id="element-57" data-mp="1shgrw2wtqbc6">
          <OrnamentDivider className="text-bronze-light" data-id="element-58" data-mp="1dtvsaiz5qu90" />
          <h1 className="mt-5 font-serif text-4xl font-normal leading-tight tracking-tight text-paper sm:text-[2.75rem]" data-id="element-59" data-mp="1dr9jyh4g0apq">
            {profile.name}
          </h1>
          <ul className="mt-4 flex flex-wrap items-center justify-center gap-x-2.5 gap-y-1.5 text-[13px] leading-snug text-bronze-light" data-id="element-60" data-mp="14rw8xk0o7e2w">
            {profile.headline.map((item, i) => <li key={item} className="flex items-center gap-2.5" data-id="element-61" data-mp="uvjhytwifebu" data-mpi={i}>
                {i > 0 && <span className="h-1 w-1 rotate-45 bg-bronze-light/70" aria-hidden="true" data-id="element-62" data-mp="zt2thm1tpd03" />}
                <span className="whitespace-nowrap" data-id="element-63" data-mp="2p8skg1qn1zkl">{item}</span>
              </li>)}
          </ul>
          <OrnamentDivider className="mt-6 text-bronze-light" data-id="element-64" data-mp="2u85d5346y0v3" />
        </figcaption>
      </div>
    </figure>;
}